<template>
    <v-card flat>
        <v-toolbar dense color="bal-gray">
            <v-toolbar-title
                >{{ $route.params.clientId === "new" ? "Add new" : activeClient.name | t }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="submitEdit" dark color="bal-red">
                <v-icon>done</v-icon>
                {{ "Save" | t }}
            </v-btn>
            <v-btn @click="closeDrawer()" icon>
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-tabs v-model="tab" background-color="bal-gray" color="bal-red">
            <v-tab v-for="item in tabs" :key="item" style="text-transform: none !important;">
                {{ item | t }}
            </v-tab>
            <v-tab-item>
                <client-info-edit-tab />
            </v-tab-item>
            <v-tab-item>
                <client-codes-edit-tab />
            </v-tab-item>
        </v-tabs>
    </v-card>
</template>

<script>
import ClientInfoEditTab from "@/pages/clients/clients-tab-items/client-info-edit-tab";
import Store from "@/store";
import { mapActions, mapState } from "vuex";
import ClientCodesEditTab from "@/pages/clients/clients-tab-items/client-codes-edit-tab";

export default {
    name: "client-edit",
    components: { ClientCodesEditTab, ClientInfoEditTab },
    data() {
        return {
            tab: 0,
            tabs: ["Client info", "Codes"]
        };
    },
    async mounted() {
        document.addEventListener("keydown", this.handleKeyboardListener);
        if (this.$route.params.clientId === "new") {
            await this.getFrequentlyUsedQueries({ users: true });
            await Store.commit("ClientStore/addNewClient");
        } else {
            await Store.dispatch("ClientStore/getClientData", this.$route.params.clientId);
        }
        if (this.$route.params.tab) {
            this.tab = this.tabs.indexOf(this.$route.params.tab);
        }
    },
    destroyed() {
        document.removeEventListener("keydown", this.handleKeyboardListener);
    },
    computed: {
        ...mapState("ClientStore", ["activeClient", "loadingClientData", "errorMessage", "requestSuccess"])
    },
    watch: {
        requestSuccess(val) {
            if (val === true && this.activeClient && this.activeClient.id) {
                this.$router.push({
                    name: "client-view",
                    params: { clientId: this.activeClient.id }
                });
            }
        }
    },
    methods: {
        ...mapActions(["getFrequentlyUsedQueries"]),
        closeDrawer() {
            this.$router.push({ name: "client-list" });
        },
        submitEdit() {
            Store.dispatch("ClientStore/submitClientUpdate", this.activeClient);
        },
        handleKeyboardListener(e) {
            if (e.keyCode === 83 && (e.metaKey || e.ctrlKey)) {
                e.preventDefault();
                this.submitEdit();
            }
            if (
                document.activeElement.tagName !== "INPUT" &&
                document.activeElement.tagName !== "TEXTAREA" &&
                document.activeElement !== document.querySelector(".ProseMirror-focused") //tipTap editor
            ) {
                if (e.key === "ArrowLeft") {
                    if (this.tab > 0) {
                        this.tab -= 1;
                    }
                } else if (e.key === "ArrowRight") {
                    if (this.tab + 1 < this.tabs.length) {
                        this.tab += 1;
                    }
                }
            }
        }
    }
};
</script>

<style scoped></style>
